import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';


export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="footer" className="footer-section">
      <div className="container footer-top">
        {/* Footer Brand Info */}
        <div className="footer-col brand-col">
          <Link to="/" className="footer-logo" style={{ display: 'flex', alignItems: 'center' }}>
            <img loading="lazy" src="/assets/images/vivify-soft-tech-logo.webp" alt="Vivify Soft Tech Logo" style={{ width: '140px', height: 'auto', objectFit: 'contain' }} title="Vivify Soft Tech" />
          </Link>
          <p className="footer-tagline">
            Empowering enterprises with AI-first software, intelligent ERP, cloud solutions, and industrial automation for smarter business growth.
          </p>
          <div className="footer-socials">
            <a
              href="https://www.linkedin.com/company/vivify-soft-tech/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              className="social-icon linkedin-icon"
            >
              <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M4 4a2 2 0 110 4 2 2 0 010-4zm0 5h4v11H4V9zm6 0h3.79v1.54h.05c.53-1 1.82-2.07 3.74-2.07 4 0 4.74 2.64 4.74 6.07V20h-4v-5.17c0-1.24-.02-2.84-1.73-2.84-1.73 0-1.99 1.35-1.99 2.75V20h-4V9z" />
              </svg>
            </a>
            <a
              href="https://www.instagram.com/vivify_soft_tech/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="social-icon"
            >
              <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M7.75 2h8.5A5.75 5.75 0 0122 7.75v8.5A5.75 5.75 0 0116.25 22h-8.5A5.75 5.75 0 012 16.25v-8.5A5.75 5.75 0 017.75 2zm0 1.5A4.25 4.25 0 003.5 7.75v8.5A4.25 4.25 0 007.75 20.5h8.5a4.25 4.25 0 004.25-4.25v-8.5A4.25 4.25 0 0016.25 3.5h-8.5zm9.5 2.31a1.06 1.06 0 110 2.12 1.06 1.06 0 010-2.12zM12 7.25a4.75 4.75 0 110 9.5 4.75 4.75 0 010-9.5zm0 1.5a3.25 3.25 0 100 6.5 3.25 3.25 0 000-6.5z" />
              </svg>
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61589751765485"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              className="social-icon"
            >
              <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.99 3.66 9.12 8.44 9.88v-6.99H7.9v-2.89h2.54V9.83c0-2.5 1.49-3.89 3.77-3.89 1.09 0 2.23.2 2.23.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56v1.88h2.78l-.44 2.89h-2.34v6.99C18.34 21.12 22 16.99 22 12z" />
              </svg>
            </a>
          </div>
        </div>

        {/* Services Column */}
        <div className="footer-col">
          <h4>Services</h4>
          <ul className="footer-links">
            <li><Link to="/services/enterprise-software-solutions">Enterprise Software Solutions</Link></li>
            <li><Link to="/services/industrial-software-automation">Industrial Automation Service</Link></li>
            <li><Link to="/services/custom-product-development">Custom Product Development</Link></li>
            <li><Link to="/services/cloud-it-services">Cloud & IT Services</Link></li>
          </ul>
        </div>

        {/* Solutions Column */}
        <div className="footer-col">
          <h4>Solutions</h4>
          <ul className="footer-links">
            <li><Link to="/solutions/ai-business-solutions">AI Business Solutions</Link></li>
            <li><Link to="/solutions/enterprise-digital-transformation">Enterprise Digital Transformation</Link></li>
            <li><Link to="/solutions/intelligent-automation-systems">Intelligent Automation Systems</Link></li>
            <li><Link to="/solutions/industrial-iot-solutions">Industrial IoT Solutions</Link></li>
            <li><Link to="/solutions/enterprise-workflow-platforms">Enterprise Workflow Platforms</Link></li>
            <li><Link to="/solutions/business-process-automation">Business Process Automation</Link></li>
            <li><Link to="/solutions/cloud-based-systems">Cloud-Based Systems</Link></li>
            <li><Link to="/solutions/scalable-enterprise-applications">Scalable Enterprise Applications</Link></li>
          </ul>
        </div>

        {/* Products Column */}
        <div className="footer-col">
          <h4>Products</h4>
          <ul className="footer-links">
            <li><Link to="/products/securai">SecurAI</Link></li>
            <li><Link to="/products/factorai">FactorAI</Link></li>
            <li><Link to="/products/smilai">SmilAI</Link></li>
          </ul>
        </div>

        {/* Contact Column */}
        <div className="footer-col">
          <h4>Contact</h4>
          <ul className="footer-links footer-contact-links">
            <li>
              <a
                href="https://www.google.com/maps/place/Vivify+Soft+Tech/@13.0958613,80.17367,17z/data=!3m1!4b1!4m6!3m5!1s0x3a5263fd873ad447:0x5966f5106b73fc96!8m2!3d13.0958613!4d80.17367!16s%2Fg%2F11w2_k9f7b"
                target="_blank"
                rel="noopener noreferrer"
                title="View Vivify Soft Tech location on Google Maps"
              >
                No. 3 &amp; 4, No. 2B, 1st Floor<br />
                Mugappair Road, Padi<br />
                Chennai, Tamil Nadu 600058
              </a>
            </li>
            <li><a href="mailto:reach@vivifysoft.com">reach@vivifysoft.com</a> (Inquiries & Sales)</li>
            <li><a href="mailto:hr@vivifysoft.com">hr@vivifysoft.com</a> (Careers)</li>
            <li><a href="tel:+917305730528">+91 7305 7305 28</a></li>
          </ul>
        </div>
      </div>

      {/* Footer Bottom Legal Section */}
      <div className="footer-bottom">
        <div className="container footer-bottom-container">
          <p className="footer-copyright">
            &copy; {currentYear} Vivify Soft Tech. All rights reserved.
          </p>
          <div className="footer-legal-links">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms">Terms &amp; Conditions</Link>
            <Link to="/sitemap">Sitemap</Link>
            <a href="/sitemap.xml" target="_blank" rel="noopener noreferrer">XML Sitemap</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
